// components/Shop/ParentCategoryPage.jsx
import React from "react";
import ProductCarousel from "./ProductCarousel";

export default function ParentCategoryPage({
  category,
  subcategoriesWithProducts = [],
}) {
  const productSections = subcategoriesWithProducts.filter(
    ({ products }) => Array.isArray(products) && products.length > 0,
  );

  const describedSubcategories = subcategoriesWithProducts.filter(
    ({ subcategory }) => subcategory?.description?.trim(),
  );

  const productsCount = productSections.reduce(
    (total, { products }) => total + products.length,
    0,
  );

  return (
    <main className="min-h-screen bg-gray-50 text-gray-800">
      <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-5 sm:py-8 lg:px-6">
        {/* Page header */}
        <header className="mb-6 sm:mb-8">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
            <div className="min-w-0">
              <h1 className="mt-3 text-lg font-bold leading-8 text-[#1E3A5F] sm:text-xl">
                {category?.name || "دسته محصولات"}
              </h1>
            </div>
            {productSections.length > 0 && (
              <div className="flex shrink-0 items-center gap-2 text-xs text-gray-500 sm:text-sm">
                <span>{productSections.length} زیردسته</span>

                <span
                  aria-hidden="true"
                  className="h-1 w-1 rounded-full bg-gray-300"
                />

                <span>{productsCount} محصول</span>
              </div>
            )}
          </div>
        </header>

        {/* Product carousels */}
        <section aria-label="محصولات زیردسته‌ها">
          {productSections.length > 0 ? (
            <div className="space-y-4 sm:space-y-6">
              {productSections.map(({ subcategory, products }) => (
                <ProductCarousel
                  key={subcategory.id}
                  title={subcategory.name}
                  products={products}
                  seeAllLink={`/shopping/product-list/?category_slug=${encodeURIComponent(
                    subcategory.slug,
                  )}`}
                />
              ))}
            </div>
          ) : (
            <div className="rounded-2xl border border-gray-200 bg-white px-4 py-12 text-center shadow-sm sm:py-16">
              <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-gray-400">
                <svg
                  className="h-6 w-6"
                  aria-hidden="true"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.75}
                    d="M20 7 12 3 4 7m16 0-8 4M20 7v10l-8 4M4 7l8 4m-8-4v10l8 4m0-10v10"
                  />
                </svg>
              </div>

              <h2 className="mt-4 text-sm font-semibold text-gray-800 sm:text-base">
                محصولی برای نمایش وجود ندارد
              </h2>

              <p className="mt-2 text-xs leading-6 text-gray-500 sm:text-sm">
                در حال حاضر محصول فعالی در زیردسته‌های این بخش ثبت نشده است.
              </p>
            </div>
          )}
        </section>

        {/* Subcategory descriptions */}
        {describedSubcategories.length > 0 && (
          <section
            aria-labelledby="subcategory-descriptions-title"
            className="mt-8 sm:mt-10"
          >
            <div className="mb-4">
              <h2
                id="subcategory-descriptions-title"
                className="text-base font-semibold text-gray-900"
              >
                معرفی دسته‌ها
              </h2>

              <p className="mt-1 text-xs leading-6 text-gray-500 sm:text-sm">
                اطلاعات بیشتر درباره دسته‌های موجود در این بخش
              </p>
            </div>

            <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
              <div className="divide-y divide-gray-100">
                {describedSubcategories.map(({ subcategory }, index) => (
                  <article
                    key={subcategory.id}
                    className="px-4 py-5 sm:px-5 sm:py-6"
                  >
                    <div className="flex items-start gap-3">
                      <span
                        aria-hidden="true"
                        className="mt-2 h-2.5 w-2.5 shrink-0 rounded-full bg-[#00AFA9]"
                      />

                      <div className="min-w-0 flex-1">
                        <h3 className="text-sm font-semibold leading-7 text-[#1E3A5F] sm:text-base">
                          <span className="ml-1 text-gray-400">
                            {index + 1}.
                          </span>
                          {subcategory.name}
                        </h3>

                        <p className="mt-2 whitespace-pre-line text-sm leading-7 text-gray-600">
                          {subcategory.description}
                        </p>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </section>
        )}
      </div>
    </main>
  );
}
